var SERVICE_VERSION_1 = 'api/v1';
var SERVICE_VERSION_2 = 'api/v2';
var PRODUCT_SERVICE = 'product';
var ORDER_SERVICE = 'order';
var USER_SERVICE = 'userservice';
var DOCUMENT_SERVICE = 'document';
var MS_API_BASE_URL = {
  DEVELOPMENT: 'https://devmssn-services.mobilitymarketplace.io',
  QA: 'https://qamss-services.boschindia-mobilitysolutions.com',
  QA_INTERNAL: 'https://internal-qamss-services.boschindia-mobilitysolutions.com',
  QA_EU: 'https://de-qamss-services.mobilitymarketplace.io',
  STAGE: 'https://stagemss-services.boschindia-mobilitysolutions.com',
  PRODUCTION: 'https://services.mobilitymarketplace.io'
};
var MS_API_CDN_URL = {
  DEVELOPMENT: 'https://pjmsmosdevcdn.azureedge.net',
  QA: 'https://pjmsqamosinsacdn.azureedge.net',
  QA_INTERNAL: 'https://pjmsqamosinsacdn.azureedge.net',
  QA_EU: 'https://pjmsqamosinsacdn.azureedge.net',
  STAGE: 'https://pjmsmosstageqacdn.azureedge.net',
  PRODUCTION: 'https://pjmsprodmosincdn.azureedge.net'
};
var MS_API_AZURE_URL_SELLER = {
  DEVELOPMENT: 'https://pjmsmssdevsa.blob.core.windows.net/',
  QA: 'https://pjmsmssqasa01.blob.core.windows.net/',
  QA_INTERNAL: 'https://pjmsmssqasa01internal.blob.core.windows.net/',
  STAGE: 'https://pjmsmssstagesa01.blob.core.windows.net/',
  PRODUCTION: 'https://stpjmsmssprod01.blob.core.windows.net/'
};
var MS_API_AZURE_URL_BUYER = {
  DEVELOPMENT: 'https://pjmsmosdevmsssa.blob.core.windows.net/',
  QA: 'https://pjmsqamosinsa01.blob.core.windows.net/',
  QA_INTERNAL: 'https://pjmsqamosinsa01.blob.core.windows.net/',
  STAGE: 'https://pjmsmosstageqasa.blob.core.windows.net/',
  PRODUCTION: 'https://pjmsprodmosinsa01.blob.core.windows.net/'
};
var tenants = {
  MOS_IND: 'mos',
  LOS_IND: 'los',
  LOS_EU: 'loseu',
  MKOS: 'mkos'
};
var roles = {
  BUYER_ROLE: 'BUYER',
  SELLER_ROLE: 'SELLER'
};
var displayRoles = {
  CUSTOMER: 'customer',
  PARTNER: 'partner'
};
var regions = {
  apacRegionCode: 'APAC',
  euRegionCode: 'EU',
  naRegionCode: 'NA'
};
var countryCodes = {
  INDIA: 'IN',
  GERMANY: 'DE',
  DENMARK: 'DK',
  NETHERLANDS: 'NL',
  SWEDEN: 'SE',
  LUXEMBOURG: 'LU',
  UNITED_STATES: 'US'
};
var errorConstants = {
  phoneNumberError: 'E000546',
  pan: 'E000066',
  systemError: 'SYSTEM_ERROR',
  panFullName: 'E000068',
  postalCode: 'E000531',
  postalCodeLength: 'E000040',
  duplicateGST: 'E000082',
  duplicateVAT: 'E000114',
  duplicateTIN: 'E000542'
};
var docIdConstants = {
  pan: '961603dd-1f1e-4461-9f8e-7cf73ca4dd6a',
  gst: '62486d06-6c75-424b-85e0-0bd6ab58b56c',
  vatId: '62486d06-6c75-424b-85e0-0bd6ab58b56c',
  w9Id: '62486d06-6c75-424b-85e0-0bd6ab58b56c',
  otherDoc: '42e1a3dd-8ceb-4aa7-a40c-d35a1184eb85'
};
var legalDocTypeIdConstants = {
  termsCondition: '36a1b008-6b44-4905-9370-007939a96292',
  legalNotice: '44189308-2508-4527-af08-ca1d63acfc56',
  corporateInfo: '4ea3fc02-dba6-4b1a-b415-1669d14b7d4e',
  termsUse: '986d9241-a8d3-4c41-bbd1-2bd9d4970c35',
  privacyPolicy: 'f439e945-c36e-4a91-979d-c2f26ba39f17'
};

// to be removed later when display name attribute is added from BE response.
// this is for temporary usage to map tenant to display exact marketplace name.
var tenantMapping = [{
  marketplaceName: 'Mobility',
  tenant: 'mos',
  region: 'IN'
}, {
  marketplaceName: 'L.OS',
  tenant: 'los',
  region: 'IN'
}, {
  marketplaceName: 'L.OS',
  tenant: 'loseu',
  region: 'EU'
}, {
  marketplaceName: 'L.OS',
  tenant: 'losna',
  region: 'NA'
}];
export { USER_SERVICE, SERVICE_VERSION_1, SERVICE_VERSION_2, MS_API_BASE_URL, MS_API_CDN_URL, MS_API_AZURE_URL_BUYER, MS_API_AZURE_URL_SELLER, PRODUCT_SERVICE, ORDER_SERVICE, DOCUMENT_SERVICE, tenants, roles, displayRoles, errorConstants, docIdConstants, legalDocTypeIdConstants, tenantMapping, countryCodes, regions };